module.exports = __webpack_public_path__ + "static/media/loader.491bbb66.svg";